<template>
  <v-container fluid style="height:100%" class="ma-0 pa-0">
    <v-row class="ma-0 pa-0" justify="center" align="center" id="sign-up">
       <v-card elevation="5"  width="622"   class="p-20 dialogcolor" >
      <!-- <v-sheet width="722" elevation="5" :tile="false" class="add-edit-wrapper"> -->
        <div class="close-btn">
          <i class="material-icons dark--text" @click="handleClose">
            clear
          </i>
        </div>
        <h2 class="headline text-center mt-n8">Reset Password?</h2>
        <v-form v-model="valid" class="org-form ma-0 pa-0 mt-5">
          <p class="input-label text-style">
            Email Address
          </p>
        <v-text-field
          ref="emailaddress"
          class="select-field customInputRound"
          label=""
          v-model="email"
          required
          solo
          outlined
          :rules="emailRules"
          validate-on-blur
          v-on:keyup.enter="submit">
        </v-text-field>
        </v-form>
        <v-row class="justify-center mr-0 ml-0">
          <v-col cols="3"></v-col>
          <v-col cols="6">
            <v-btn class="save-btn mb-29 text-style mt-4"
              depressed
              :disabled="!email"
              @click="submit">
              Reset Password
            </v-btn>
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>
       </v-card>
      <!-- </v-sheet> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ResetPassword',
  data () {
    return {
      valid: false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ]
    }
  },

  methods: {
    handleClose () {
      if (this.$route.query.isLogged) {
        this.$router.go(-1)
      } else {
        this.$router.push('/session/login')
      }
    },

    submit () {
      this.$store.dispatch('resetPassword', this.email)
    }
  },
  mounted () {
    this.$nextTick(() => this.$refs.emailaddress.focus())
  }
}
</script>

<style lang="scss">
  #sign-up {
    height: 100%;
    background-color: #F3F3F2;
    .login-btn {
      margin-top: 14px;
    }

    .v-input {
      input {
        color: $black-color;
        font-weight: bold;
        font-size: 18px;
        line-height: 32px;
      }
    }

    .input-label {
      text-transform: uppercase !important;
      font-weight: bold !important;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 2.125px;
      color: $black-color !important;
    }
  }
.dialogcolor{
  border-radius: 25px !important;
  border: 2px solid $primary-color !important;
}
</style>
